import { useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollToTop } from '@/lib/scrollToTop'

/** Scroll window to top when navigating to a new route (not on in-page query updates). */
export function ScrollToTop() {
  const { pathname } = useLocation()
  const previousPathnameRef = useRef(pathname)

  useLayoutEffect(() => {
    if (previousPathnameRef.current === pathname) return
    previousPathnameRef.current = pathname
    scrollToTop()
  }, [pathname])

  return null
}
